<action class="cursor-pointer"
        [status]="status"
        (click)="toggle()">
    <i class="icon-trash"
       #iconHeartLeftRef></i>
</action>
<result class="block pos-absolute top-100"
        [status]="status" />